import { PaymentStatus } from './enum';
import { CurrencyType } from '@/js/enum';
import eventBus from './event-bus';
import Decimal from 'decimal.js';
export default {
	computed: {
		Dong() {
			return this.getIdByEnum(CurrencyType.VietDong);
		},
		Dollar() {
			return this.getIdByEnum(CurrencyType.UsDollar);
		},
		customers() {
			return this.$store.getters['customers'];
		},
		currentUser() {
			return this.$store.getters['currentUser'];
		},
		currencySymbol() {
			let us = this.getIdByEnum(CurrencyType.UsDollar);
			let viet = this.getIdByEnum(CurrencyType.VietDong);
			if (this.product.currencyId == us) {
				return '$';
			} else if (this.product.currencyId == viet) {
				return '₫';
			}
			return '';
		},

		isLoggedIn() {
			return this.$store.getters['isLoggedIn'];
		},
		isAdmin() {
			return this.$store.getters['isAdmin'];
		},
		isRoot() {
			return this.$store.getters['isRoot'];
		},

		idToOption() {
			return this.$store.getters['idToOption'];
		},
		enumToOption() {
			return this.$store.getters['enumToOption'];
		},
		userFullName() {
			if (this.isLoggedIn && this.currentUser) {
				return this.currentUser.first + ' ' + this.currentUser.last;
			}
			return '';
		},
		users() {
			return this.$store.getters['users'];
		},
		vendors() {
			return this.$store.getters['vendors'];
		},
		yesNo() {
			return [
				{
					text: 'Yes',
					value: true,
				},
				{ text: 'No', value: false },
			];
		},
	},
	methods: {
		checkIfPaid(paymentStatusId) {
			return paymentStatusId == this.getIdByEnum(PaymentStatus.Paid);
		},
		convertToUsDate(val) {
			if (!val) return '';
			if (!val.includes('T')) val = val + 'T00:00:00';

			return new Date(val).toLocaleDateString();
		},
		convertToUsDollar(val) {
			val = new Decimal(val);
			return val.dividedBy(new Decimal(26000));
		},
		convertToDate(date, isUtc = true) {
			if (!date) return '';

			if (isUtc) {
				const tmp = new Date(date + 'Z');
				return tmp.toLocaleString();
			} else {
				if (date.includes('T')) date = date.split('T')[0];
				const [year, month, day] = date.split('-');
				return `${month.padStart(2, '0')}/${day.padStart(
					2,
					'0'
				)}/${year}`;
			}
		},
		convertToDecimal(val) {
			return (val / 100).toFixed(2);
		},
		convertToCleanNumber(val, isDecimal = true) {
			if (!val && isDecimal) return '0.00';
			else if (!val && !isDecimal) return '0';
			let typeStr = typeof val;
			if (typeStr === 'object') val = val.toNumber();
			if (isDecimal) {
				return val.toLocaleString('en-US', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				});
			} else {
				return val.toLocaleString('en-US', {
					minimumFractionDigits: 0,
					maximumFractionDigits: 0,
				});
			}
		},
		formatInvoiceId(invoice) {
			return `${this.getOptionName(
				invoice.typeId
			)[0].toUpperCase()}-${String(invoice.id).padStart(5, '0')}`;
		},
		parseDate(date) {
			if (!date) return null;
			if (date.includes('T')) date = date.split('T')[0];
			const [month, day, year] = date.split('/');
			return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
		},
		timer(val) {
			let promise = new Promise((resolve) => {
				setTimeout(() => {
					resolve();
				}, val);
			});
			return promise;
		},
		getCustomerName(id, phone = true) {
			if (!id) return '';
			let customer = this.customers.find((e) => e.id == id);
			if (customer) {
				let toReturn = customer.name;
				if (phone) toReturn += ` - ${customer.phone}`;
				return toReturn;
			}
			return '';
		},
		getVendorName(id, phone = false) {
			if (!id) return '';
			let vendor = this.vendors.find((e) => e.id == id);
			if (vendor) {
				let toReturn = vendor.name;
				if (phone) toReturn += ` - ${vendor.phone}`;
				return toReturn;
			}
			return '';
		},
		getCurrencySymbol(id) {
			let us = this.getIdByEnum(CurrencyType.UsDollar);
			let viet = this.getIdByEnum(CurrencyType.VietDong);
			if (id == us) {
				return '$';
			} else if (id == viet) {
				return '₫';
			}
			return '';
		},
		getIdByEnum(e) {
			if (this.enumToOption && this.enumToOption[e])
				return this.enumToOption[e].id;
			return null;
		},
		getEnum(optionId) {
			if (
				this.idToOption &&
				this.idToOption[optionId] &&
				this.idToOption[optionId].customEnum
			) {
				return this.idToOption[optionId].cutomEnum;
			}
			return null;
		},
		getOptionName(optionId) {
			if (this.idToOption && this.idToOption[optionId]) {
				return this.idToOption[optionId].displayName;
			}
			return 'N/A';
		},
		getUserName(id) {
			const user = this.users.find((e) => e.id == id);
			if (user) return `${user.first} ${user.last}`;
			return '';
		},
		successSnackbar(message) {
			eventBus.$emit('setSnackbar', message, 'success', true);
		},
		errorSnackbar(message) {
			eventBus.$emit('setSnackbar', message, 'error', true);
		},
		convertOrdertoCart(order) {
			let cart = {};
			for (let i = 0; i < order.orderDetails.length; i++) {
				let orderDetail = order.orderDetails[i];
				if (!cart[orderDetail.productId]) {
					let product = {};
					product.title = orderDetail.productTitle;
					product.id = orderDetail.productId;
					product.unitPrice = orderDetail.unitPrice;
					product.pictureId = orderDetail.pictureId;
					product.currencyId = orderDetail.currencyId;
					let item = {
						product: product,
						count: orderDetail.quantity,
					};
					cart[product.id] = item;
				}
			}
			return cart;
		},
	},
};
